import {SessionTemplateRestService} from './restServices';
import storageService from '../storageService';

var service = {};
service.createSessionTemplate = (
  mentorId,
  sessionTemplateData,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  console.debug(token ? token : storageService.getItem('token'));
  console.debug('trying to create SessionTemplate: ');
  console.debug(sessionTemplateData);
  // defaults : session type is TIME_LIMIT.
  sessionTemplateData.sessionCostPerMinute = 0;
  sessionTemplateData.sessionType = 'TIME_LIMIT';
  // end defaults

  var newSessionTemplateRequestObject = {
    token: token ? token : storageService.getItem('token'),
    sessionTemplateDto: sessionTemplateData,
  };

  SessionTemplateRestService.save(
    {
      endpoint: 'mentorId',
      endpointParam: mentorId,
    },
    newSessionTemplateRequestObject,
    function (resource) {
      console.debug(resource);
      successCallbackFunction(resource.sessionTemplateDto);
    }, // success
    function (response) {
      failCallbackFunction(response.data);
      console.debug(response.data);
    },
  ); // failure
};
service.getSessionTemplateBySessionTemplateId = (
  sessionTemplateId,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  var requestObject = {
    endpoint: 'sessionTemplateId',
    endpointParam: sessionTemplateId,
    token: token ? token : storageService.getItem('token'),
  };
  SessionTemplateRestService.get(
    requestObject,
    {},
    function (resource) {
      // success
      console.debug(resource);
      if (successCallbackFunction) {
        successCallbackFunction(
          service.parseInteger(resource.sessionTemplateDto),
        );
      } else {
        return resource.sessionTemplateDto;
      }
    },
    function (response) {
      // failure
      console.debug(response.data);
      if (failCallbackFunction) {
        failCallbackFunction(response);
      }
      return null;
    },
  );
};
service.getSessionTemplatesByMentorId = (
  mentorId,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  var requestObject = {
    endpoint: 'mentorId',
    endpointParam: mentorId,
    token: token ? token : storageService.getItem('token'),
  };

  SessionTemplateRestService.get(
    requestObject,
    {},

    function (resource) {
      // success
      if (successCallbackFunction) {
        successCallbackFunction(
          service.parseIntegers(resource.sessionTemplatesDto),
        );
      } else {
        return resource.sessionTemplatesDto;
      }
    },
    function (response) {
      // failure
      console.debug('response is', response);
      if (failCallbackFunction) {
        failCallbackFunction();
      }
      return null;
    },
  );
};

service.getSessionTemplatesByMentorIdAndSessionType = (
  mentorId,
  sessionType,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  const requestObject = {
    endpoint: 'mentorId',
    endpointParam: mentorId,
    endpoint2: 'paymentFlow',
    endpointParam2: sessionType,
    token: token ? token : storageService.getItem('token'),
  };

  SessionTemplateRestService.get(
    requestObject,
    {},
    (resource) => {
      // success
      if (successCallbackFunction) {
        successCallbackFunction(
          service.parseIntegers(resource.sessionTemplatesDto),
        );
      } else {
        return resource.sessionTemplatesDto;
      }
    },
    (response) => {
      // failure
      console.debug('Error: ', response);
      if (failCallbackFunction) {
        failCallbackFunction();
      }
      return null;
    },
  );
};

service.updateSessionTemplateBySTId = (
  sessionTemplateId,
  sessionTemplateDto,
  successCallbackFunction,
  failCallbackFunction,
) => {
  var requestObject = {
    token: storageService.getItem('token'),
    sessionTemplateDto: sessionTemplateDto,
  };

  SessionTemplateRestService.update(
    {
      endpoint: 'sessionTemplateId',
      endpointParam: sessionTemplateId,
    },
    requestObject,
    function (resource) {
      console.debug(resource);
      if (successCallbackFunction) {
        successCallbackFunction(resource.sessionTemplateDto);
      }
    }, // success
    function (response) {
      failCallbackFunction(response);
      console.debug(response.data);
    },
  ); // failure
};

service.parseIntegers = (sessionsDto) => {
  if (sessionsDto !== null && sessionsDto !== undefined) {
    var session = service.parseInteger(sessionsDto[0]); // later - should do it for all the session templates
    sessionsDto[0] = session;
  }
  return sessionsDto;
};

service.parseInteger = (sessionTemplateDto) => {
  if (sessionTemplateDto !== null && sessionTemplateDto !== undefined) {
    sessionTemplateDto.sessionCost = +sessionTemplateDto.sessionCost; // the '+' sign makes it an integer
    sessionTemplateDto.sessionTimeLimit = +sessionTemplateDto.sessionTimeLimit;
  }
  return sessionTemplateDto;
};

service.deleteSessionTemplateBySessionTemplateId = (
  sessionTemplateId,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  var requestObject = {
    endpoint: 'delete',
    endpointParam: sessionTemplateId,
    token: token ? token : storageService.getItem('token'),
  };
  SessionTemplateRestService.save(
    requestObject,
    function (resource) {
      // success
      console.debug(resource);
      if (successCallbackFunction) {
        successCallbackFunction(
          service.parseIntegers(resource.sessionTemplatesDto),
        );
      } else {
        return resource.sessionTemplatesDto;
      }
    },
    function (response) {
      // failure
      console.debug(response.data);
      failCallbackFunction(response.data);
    },
  );
};

const sessionTemplateService = {...service};
export default sessionTemplateService;
